import { useState, useEffect } from 'react'
import GatedContentForm from 'components/GatedContentForm'
import GatedContentModal from 'components/GatedContentModal'
import GatedContentThankYou from 'components/GatedContentThankYou'
import BigModal from 'components/BigModal'
import { useAnalytics } from 'clientHelpers/context/analyticsContext'
import styles from './styles'

const MarketingBanner = () => {
  const { addTrackingForCTA } = useAnalytics()
  const [isModalOpen, setModalOpen] = useState(false)

  // TODO: Render form thank you state
  const [formImage, setFormImage] = useState('form_header.png')
  const [modalHeading, setModalHeading] = useState('Get a marketplace report on OfferZen developers')
  const [showThankYouMessage, setShowThankYouMessage] = useState(false)

  const handleOpenModal = () => {
    // TODO: Add Analytics tracking when report button is clicked
    setModalOpen(true)
  }

  const handleCloseModal = () => {
    // TODO: Add form modal to be handled when a user closes the form
    setModalOpen(false)
  }

  useEffect(() => {
    if (showThankYouMessage) {
      setFormImage('success_dinocorn.png')
      setModalHeading('Your marketplace report is on the way! ✉️')
    }
  }, [showThankYouMessage])

  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.bannerContainer}>
          <img
            src={`${process.env.NEXT_PUBLIC_BASEPATH}/assets/marketing_banner/icon.png`}
            alt="banner icon"
            className={styles.bannerIcon}
          />
          <div>
            <h3 className={styles.bannerHeading}>Request a marketplace report on OfferZen developers</h3>
            <p className={styles.bannerContent}>
              We&apos;ll email you a breakdown of the top skills, work preferences, and experience of developers on OfferZen.
            </p>
          </div>
          <button
            {...addTrackingForCTA({
              action: 'clicked get report',
              sourceDetail: 'gated content report banner',
            })}
            className={styles.bannerButton}
            onClick={handleOpenModal}>
            Get report
          </button>
        </div>
      </div>
      <BigModal open={isModalOpen} handleClose={handleCloseModal} handleOpen={handleOpenModal}>
        {({ close }) => {
          return (
            <GatedContentModal thankYouClassName={showThankYouMessage ? styles.thankYouWrapper : ''}>
              <div className={styles.formHeader}>
                <button onClick={() => handleCloseModal()} className={styles.closeButton}>
                  <img src={`${process.env.NEXT_PUBLIC_BASEPATH}/assets/close_arrow.svg`} />
                </button>
                <h3 className={styles.formHeading}>{modalHeading}</h3>
                <img
                  className={styles.formImage}
                  src={`${process.env.NEXT_PUBLIC_BASEPATH}/assets/marketing_banner/${formImage}`}
                  alt="Dinocorn with a blackboard containing writing and graphs"
                />
              </div>
              {!showThankYouMessage && <GatedContentForm setShowThankYouMessage={setShowThankYouMessage} />}
              {showThankYouMessage && <GatedContentThankYou />}
            </GatedContentModal>
          )
        }}
      </BigModal>
    </>
  )
}

export default MarketingBanner
